import { Dialog } from '@bloomfieldrobotics/canopy';
import { DialogContent, Stack } from '@mui/material';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const RanchWidgetDialog = ({ isOpen, onClose, children }: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <Stack
          direction='column'
          justifyContent='space-between'
          height='30vh'
          width='50vw'
        >
          {children}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
